import { ListItem, ListItemProps } from '@/components';
import TokenIcon from '@/components/organisms/TokenIcon/TokenIcon';
import { TokenInterface } from '@/interfaces/TokenInterface';
import { FC, ReactNode } from 'react';
export interface TokenListItemProps extends Omit<ListItemProps, 'mainText'> {
  token: TokenInterface;
  showNetwork?: boolean;
  showNetworkPrefix?: boolean;
  showTicker?: boolean;
  showTickerInMainText?: boolean;
  showSubNetworkNextToMainNetwork?: boolean;
  applyRoundedMask?: boolean;
}
const TokenListItem: FC<TokenListItemProps> = ({
  token,
  isHeader = false,
  leftIcon,
  leftIconUrl,
  leftIconWidth,
  leftIconHeight,
  showNetwork = false,
  showNetworkPrefix = false,
  showTicker = false,
  showTickerInMainText = true,
  showSubNetworkNextToMainNetwork = false,
  applyRoundedMask,
  ...rest
}) => {
  const iconSize = isHeader ? 40 : 36;
  const iconWidth = leftIconWidth ?? iconSize;
  const iconHeight = leftIconHeight ?? iconSize;
  const renderLeftIcon = () =>
    leftIcon || (
      <TokenIcon
        key={`${token.symbol}-${token.address}`}
        token={token}
        tokenSymbol={token.symbol}
        alt={token.name}
        width={iconWidth}
        height={iconHeight}
        applyRoundedMask={applyRoundedMask}
      />
    );
  const formatNetworkDisplay = (
    network: string,
    isSubNetwork: boolean = false,
  ) =>
    showNetworkPrefix
      ? `${isSubNetwork ? 'Sub-network ' : 'Network '}${network}`
      : network;
  const tokenBlockchainDisplayName =
    token.blockchainDisplayName || token.blockchain || '';
  let mainText: ReactNode = token.name;
  let subText: ReactNode = '';
  let subSubText: ReactNode = '';
  if (showTicker && showTickerInMainText) {
    mainText = token.symbol;
    if (showNetwork) {
      subText = formatNetworkDisplay(tokenBlockchainDisplayName);
    } else {
      subText = token.name;
    }
  } else if (showTicker && !showTickerInMainText) {
    mainText = token.name;
    subText = token.symbol;
    if (showNetwork) {
      subSubText = formatNetworkDisplay(tokenBlockchainDisplayName);
    }
  } else if (showNetwork) {
    mainText = token.name;
    subText = formatNetworkDisplay(tokenBlockchainDisplayName);
  }
  if (showNetwork && showSubNetworkNextToMainNetwork) {
    subText = formatNetworkDisplay(tokenBlockchainDisplayName);
    subSubText = '';
  }
  return (
    <ListItem
      isHeader={isHeader}
      mainText={mainText}
      subText={subText}
      subSubText={subSubText}
      leftIcon={renderLeftIcon()}
      leftIconWidth={iconWidth}
      leftIconHeight={iconHeight}
      leftIconUrl={leftIconUrl}
      {...rest}
    />
  );
};
export default TokenListItem;
